import { doc, getDoc, onSnapshot, setDoc } from 'firebase/firestore';
import { db } from './firebase';
import type { DerivationSettings } from '@watchkeeper/shared-types';

const ADMIN_CONFIG_COLLECTION = 'admin_config';
const DERIVATION_SETTINGS_DOC_ID = 'derivation_settings';

function derivationSettingsDocRef() {
  return doc(db, ADMIN_CONFIG_COLLECTION, DERIVATION_SETTINGS_DOC_ID);
}

export const DEFAULT_DERIVATION_SETTINGS: DerivationSettings = {
  enforceInHouseBrandConstraint: true,
};

export async function getDerivationSettings(): Promise<DerivationSettings> {
  const snapshot = await getDoc(derivationSettingsDocRef());
  if (!snapshot.exists()) return DEFAULT_DERIVATION_SETTINGS;
  const data = snapshot.data() as Partial<DerivationSettings>;
  return {
    enforceInHouseBrandConstraint:
      typeof data.enforceInHouseBrandConstraint === 'boolean'
        ? data.enforceInHouseBrandConstraint
        : DEFAULT_DERIVATION_SETTINGS.enforceInHouseBrandConstraint,
  };
}

export async function setDerivationSetting<K extends keyof DerivationSettings>(
  key: K,
  value: DerivationSettings[K],
): Promise<void> {
  await setDoc(derivationSettingsDocRef(), { [key]: value }, { merge: true });
}

export function subscribeToDerivationSettings(
  callback: (settings: DerivationSettings) => void,
): () => void {
  return onSnapshot(derivationSettingsDocRef(), (snapshot) => {
    if (!snapshot.exists()) {
      callback(DEFAULT_DERIVATION_SETTINGS);
      return;
    }
    const data = snapshot.data() as Partial<DerivationSettings>;
    callback({
      enforceInHouseBrandConstraint:
        typeof data.enforceInHouseBrandConstraint === 'boolean'
          ? data.enforceInHouseBrandConstraint
          : DEFAULT_DERIVATION_SETTINGS.enforceInHouseBrandConstraint,
    });
  });
}
